import { appConstants } from "JS/Helpers/Constants";
import { config } from "JS/Config";
import { MediaEssentials } from "JS/Models/MediaEssentials";
import { BaseService } from "../BaseService";

export class MediaEssentialsService extends BaseService {
    getMediaEssentials(): Promise<MediaEssentials> {
        return this.ngCall<MediaEssentials>(
            "get",
            appConstants.ngEndpoints.s3File,
            {
                params: {
                    bucketName: config.s3.mediaEssentials.bucketName,
                    filePath: config.s3.mediaEssentials.key,
                },
            },
        ).then((response) => response.data);
    }
}
